// Deploy-time configuration injected into the served SPA by the frontend container's
// entrypoint (build/docker-entrypoint.d/30-runtime-config.sh), which writes
// window.__BL312_ENV_LABEL__ from the container's ENV_LABEL. Absent under `ng serve` (the
// dev server ships the no-op public/runtime-config.js), so no banner shows locally. The
// environment banner is a pure RUNTIME concern: the same prod image shows "Pre-production"
// on pre-prod and no banner on prod, driven only by the container's ENV_LABEL.

declare global {
  interface Window {
    __BL312_ENV_LABEL__?: string;
  }
}

export function runtimeEnvironmentLabel(): string | null | undefined {
  return typeof window !== 'undefined' ? window.__BL312_ENV_LABEL__ : undefined;
}
